const es = {
  home: {
    biometric_label: "VERIFICACIÓN DE IDENTIDAD BIOMÉTRICA",
    title: "Búsqueda inversa de caras",
    description:
      "Sube un retrato de alta resolución para cruzar referencias con archivos digitales globales usando coincidencia neuronal avanzada.",
    drag_drop: "Arrastra y suelta tu imagen",
    file_formats: "Admite RAW, JPEG o PNG (Máx 15MB)",
    select_file: "SELECCIONAR ARCHIVO DEL SISTEMA",
    initiate_scan: "Iniciar Análisis Forense",
    upload_hint: "POR FAVOR SUBE UNA IMAGEN PARA CONTINUAR",
    uploading: "Subiendo",
    searching: "Escaneando",
    result_title: "Resultados",
    drop_here: "Suelta la imagen aquí...",
    billion_faces: "Compara con más de 1 mil millones de caras en internet",
    login_to_search: "Iniciar sesión para buscar",
    login_required: "Inicia sesión o crea una cuenta para usar esta app",
    not_enough_tokens: "Tokens insuficientes",
    please_wait: "Por favor espera un par de minutos",
    leave_confirmation:
      "Hay un proceso en curso. ¿Estás seguro de que quieres salir?",
  },
  sources: {
    section_title: "Fuentes que Consultamos",
    social_media: {
      name: "Redes Sociales",
      description:
        "Cruza referencias en las principales redes sociales y perfiles públicos.",
    },
    web: {
      name: "Web",
      description:
        "Escanea la web abierta en busca de datos de caras disponibles públicamente.",
    },
    scammers: {
      name: "Estafadores",
      description:
        "Compara con bases de datos de identidad de estafadores conocidos.",
    },
    sexual_offenders: {
      name: "Delincuentes Sexuales",
      description:
        "Cruza referencias con registros públicos de delincuentes registrados.",
    },
    videos: {
      name: "Videos",
      description: "Extrae y compara caras de plataformas de video públicas.",
    },
    police_photos: {
      name: "Fotos Policiales",
      description:
        "Compara con bases de datos de registros policiales disponibles públicamente.",
    },
    news_and_blogs: {
      name: "Noticias y Blogs",
      description:
        "Busca en archivos de noticias, contenido editorial y blogs.",
    },
  },
  header: {
    scan: "ESCANEAR",
    history: "HISTORIAL",
    pricing: "PRECIOS",
    account: "CUENTA",
    logout: "CERRAR SESIÓN",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. Todos los derechos reservados. Verificación de Identidad de Precisión.",
    privacy: "Política de Privacidad",
    terms: "Términos de Servicio",
    docs: "Documentación",
    support: "Soporte",
  },
  common: {
    loading: "Cargando...",
    error: "Error",
    cancel: "Cancelar",
    back: "Atrás",
  },
  errors: {
    upload_failed: "Error al subir. Inténtalo de nuevo.",
    not_enough_tokens:
      "No tienes suficientes tokens para realizar esta búsqueda.",
  },
  login: {
    disclaimer:
      "Necesitas una cuenta para usar esta app. No enviamos spam ni compartimos tu correo. Te sugerimos iniciar sesión con Apple para mantener tu privacidad.",
  },
  results: {
    input_source: "FUENTE DE ENTRADA",
    match_thumbnail: "Miniatura de la coincidencia",
    extraction_id: "ID DE EXTRACCIÓN",
    scan_analysis: "Análisis del escaneo",
    scan_description:
      "Búsqueda biométrica inversa completada. Se encontraron %{count} coincidencias potenciales en registros públicos e índices sociales.",
    col_identity_map: "MAPA DE IDENTIDAD",
    col_verification_path: "RUTA DE VERIFICACIÓN",
    col_bio_match_score: "PUNTUACIÓN BIO",
    col_action: "ACCIÓN",
    export_pdf: "Exportar PDF",
    exporting: "Generando...",
    verified: "VERIFICADO",
    details: "DETALLES",
    details_tooltip: "Ejecutar comparación facial precisa",
    details_loading: "Comparando...",
    copied: "¡Copiado!",
    copy_url: "Copiar URL",
    displaying: "Mostrando %{count} de %{total} detecciones",
  },
};

export default es;
